










import NoSSR from 'vue-no-ssr';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AdvCreative } from '../adv-creative';
import type { AdvData } from '../adv-mobile-sticky-rsya/adv-mobile-sticky-rsya-body.component';


@Component({
  name: 'AdvFlyroll',
  components: {
    AdvCreative,
    NoSSR
  }
})
export default class AdvFlyroll extends Vue {
  @Prop({
    required: true,
    type: Object
  })
  advData: AdvData;

  isFlyrollClosed = false;

  trackFlyrollDestroyed () {
    this.isFlyrollClosed = false;
    const onFlyrollDestroyed = () => {
      this.isFlyrollClosed = true;
      setTimeout(() => {
        this.trackFlyrollDestroyed();
      }, 150 * 1000);
      window.removeEventListener('viqeoFlyrollDestroyed', onFlyrollDestroyed);
    };

    window.addEventListener('viqeoFlyrollDestroyed', onFlyrollDestroyed);
  }

  mounted() {
    this.trackFlyrollDestroyed();
  }

  beforeDestroy() {
    window.removeEventListener('viqeoFlyrollDestroyed', () => {});
  }
}
